import { render, staticRenderFns } from "./MonitorItem.vue?vue&type=template&id=1a85c0ce&scoped=true"
import script from "./MonitorItem.vue?vue&type=script&lang=js"
export * from "./MonitorItem.vue?vue&type=script&lang=js"
import style0 from "./MonitorItem.vue?vue&type=style&index=0&id=1a85c0ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85c0ce",
  null
  
)

export default component.exports